import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { withTranslation, WithTranslation } from 'react-i18next';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ApplicationState } from 'store/rootReducer';
import { connect } from 'react-redux';
import {
  closeUpgradeMockModalAction,
  showUpgradeDropDownLoadingAction,
  upgradeAllMockServicesUnderLocationThunk,
  upgradeMockServiceThunk,
} from 'store/mockServices/mockServiceList/mockServiceListActions';
import MockServiceUpgradeDropdown from './MockServiceUpgradeDropDown';
import { MockService } from 'types/rest/mockServiceTypes';
import { getLocationName } from 'utils/mockServiceUtils';
import BzmIcon from 'components/icons/BzmIcon';
import { Alert } from 'react-bootstrap';
import _ from 'lodash';
import { TRANSACTION_THRESHOLD_LIMIT } from 'constants/bzm-constants';

interface LocalProps {
  show: boolean;
  mockService?: MockService;
  isUpgrading?: boolean;
}

type AllProps = MapToStateProps & DispatchProps & WithTranslation & LocalProps & RouteComponentProps<any>;

class MockServiceWarningsModal extends React.Component<AllProps, LocalProps> {
  state = {
    show: false,
    isUpgrading: false,
  };
  componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<LocalProps>, snapshot?: any) {
    if (prevProps.mockService !== this.props.mockService) {
      if (prevProps.mockService && prevProps.mockService?.metaData && prevProps.mockService?.metaData.inProgress) {
        this.setState({ isUpgrading: true });
      } else if (
        prevProps.mockService &&
        prevProps.mockService?.metaData &&
        prevProps.mockService?.metaData.isDeployed
      ) {
        this.setState({ isUpgrading: false });
      }
    }
  }

  onCancel = () => {
    this.props.closeUpgradeMockModalAction();
  };

  handleChangeStatus = (status: any) => {
    if (status === 'ALLMOCKS') {
      this.props.showUpgradeDropDownLoadingAction();
      this.props.upgradeAllMockServicesUnderLocationThunk(this.props.mockService);
    } else if (status === 'MOCK') {
      this.setState({ isUpgrading: true });
      if (this.props.mockService) this.props.upgradeMockServiceThunk(this.props.mockService);
    }
  };
  render() {
    const { t, mockService } = this.props;
    const name = mockService ? mockService?.name : '';
    const isUpgradeAvailable = _.get(mockService, 'metadata.warnings.upgradeAvailable', false);
    const isAnalyticsMissing = _.get(mockService, 'metadata.warnings.analyticsDataMissing', false);
    const locationUnknown = _.get(mockService, 'metadata.warnings.locationUnknown', false);
    const txnLimit = _.get(mockService, 'metadata.limits.percentage', 0);

    let newVersion: string;
    if (
      this.props.blazeUserConfig != null &&
      this.props.blazeUserConfig.config != null &&
      this.props.blazeUserConfig.config.version != null
    )
      newVersion = this.props.blazeUserConfig.config.version;
    else newVersion = '';
    const mockOldVersion = mockService?.metadata ? mockService?.metadata.version : '';

    const locName = getLocationName(
      mockService?.harborId ? mockService?.harborId : null,
      mockService?.shipId ? mockService?.shipId : null,
    );

    return (
      <Modal
        id={'qa-modal-mock-upgrade' + mockService?.id}
        show={this.props.show}
        centered={true}
        backdrop={true}
        onHide={this.onCancel}
      >
        <Modal.Header closeButton id="qa-modal-assign-template-btn-close-icon">
          <h5 className="modal-title">
            {t('upgradeMockModal.mockServiceWarnings')} (<span className="text-muted">{name}</span>){' '}
          </h5>
        </Modal.Header>
        <Modal.Body>
          {isUpgradeAvailable && (
            <div className="alert alert-warning" role="alert">
              <BzmIcon variant={'icon-bzm-caution'} className={'alert-icon'} />
              <MockServiceUpgradeDropdown
                changeStatusHandler={this.handleChangeStatus}
                isUpgrading={this.state.isUpgrading ? this.state.isUpgrading : this.props.showUpgradeLoading}
                mockService={mockService ? mockService : undefined}
              />
              <p className="alert-message mb-0">
                {t('upgradeMockModal.mockServiceUpgradeWarningMsg')}{' '}
                <b>
                  {' '}
                  {t('upgradeMockModal.version')} {mockOldVersion}
                </b>
                . {t('upgradeMockModal.mockServiceUpgradeWarningMsg1')}{' '}
                <b>
                  {' '}
                  {t('upgradeMockModal.version')} {newVersion}
                </b>
                {t('upgradeMockModal.mockServiceUpgradeWarningMsg2')}
                <b>{locName}</b>. {t('upgradeMockModal.mockServiceUpgradeWarningMsg3')}{' '}
              </p>
            </div>
          )}

          {/* Analytics data is missing */}
          {isAnalyticsMissing && (
            <Alert variant={'warning'}>
              <BzmIcon variant={'icon-bzm-caution'} className={'alert-icon'} />
              <p className="alert-message mb-0">{t('upgradeMockModal.mockServiceAnalyticsWarningMsg')}</p>
              <a href="#">
                {' '}
                <i className={'js-analytics-transaction-help ml-1'} style={{ fontStyle: 'initial' }}>
                  See Documentation
                </i>
              </a>
            </Alert>
          )}
          {/* Location is unknown */}
          {locationUnknown && (
            <Alert variant={'warning'}>
              <BzmIcon variant={'icon-bzm-caution'} className={'alert-icon'} />
              <p className="alert-message mb-0">{t('upgradeMockModal.mockServiceImageUnknownMsg')}</p>
            </Alert>
          )}
          {txnLimit >= TRANSACTION_THRESHOLD_LIMIT && (
            <Alert variant={'warning'}>
              <BzmIcon variant={'icon-bzm-caution'} className={'alert-icon'} />
              <p className="alert-message mb-0">
                {/* Reaching the limit */}
                {txnLimit >= TRANSACTION_THRESHOLD_LIMIT &&
                  txnLimit < 100 &&
                  `Virtual Service transaction limit is going to be exceeded soon. Current consumption is: ${txnLimit} %`}

                {/* Over the Limit */}
                {txnLimit >= 100 && 'Virtual Service transaction limit has been exceeded.'}
              </p>
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button id={'qa-modal-mock-upgrade-btn-done'} variant="primary" onClick={this.onCancel}>
            {t('upgradeMockModal.close')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = ({ mockservices, blazeUserConfig }: ApplicationState) => ({
  locData: mockservices.locData,
  showUpgradeLoading: mockservices.showUpgradeLoading,
  isUpgradeMockModalOpen: mockservices.isUpgradeMockModalOpen,
  isPrivateCloudReadOnly: blazeUserConfig.isPrivateCloudReadOnly,
  blazeUserConfig: blazeUserConfig.blazeUserConfig,
});

const mapDispatchToProps = {
  closeUpgradeMockModalAction,
  upgradeMockServiceThunk,
  upgradeAllMockServicesUnderLocationThunk,
  showUpgradeDropDownLoadingAction,
};

type MapToStateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default withRouter(
  withTranslation('mockServices')(connect(mapStateToProps, mapDispatchToProps)(MockServiceWarningsModal)),
);
